// Initial state
import Vue from "vue";
import FileService from "@/helpers/FileService";

const getDefaultState = function () {
    return {
        fileInputs: {},
        fileInLoading: {},
    };
};


const state = getDefaultState();

// getters
const getters = {
    getFileInputs: (state) => {
        //console.log("Getter: ", state.fileInputs);
        return state.fileInputs;
    },
    getFileInLoading: (state) => {
        //console.log("Getter: ", state.fileInLoading);
        return state.fileInLoading;
    },
};

// actions
const actions = {
    resetState({commit}) {
        commit("resetState");
    },
    setFilesInput({commit}, fileInputsState) {
        commit("setFilesInput", fileInputsState);
        //console.log('FileInputState -> setFilesInput: ', state.fileInputs);
    },
    addFilesInput({commit}, fileInputsState) {
        commit("addFilesInput", fileInputsState);
        //console.log('FileInputState -> addFilesInput: ', state.fileInputs);
    },
    deleteFileInput({commit}, fileInputsState) {
        commit("deleteFileInput", fileInputsState);
        //console.log('FileInputState -> deleteFileInput: ', state.fileInputs);
    },
    setFilesInLoading({commit}, fileInLoadingState) {
        commit("setFilesInLoading", fileInLoadingState);
        //console.log('FileInputState -> setFilesInLoading: ', state.fileInLoading);
    },
    addFilesInLoading({commit}, fileInLoadingState) {
        commit("addFilesInLoading", fileInLoadingState);
        //console.log('FileInputState -> addFilesInLoading: ', state.fileInLoading);
    },
    deleteFileInLoading({commit}, fileInLoadingState) {
        commit("deleteFileInLoading", fileInLoadingState);
        //console.log('FileInputState -> deleteFileInLoading: ', state.fileInLoading);
    },
    updateFileInLoading({commit}, fileInLoadingState) {
        commit("updateFileInLoading", fileInLoadingState);
        //console.log('FileInputState -> updateFileInLoading: ', state.fileInLoading);
    },
};

// mutations
const mutations = {
    resetState(state) {
        Object.assign(state, getDefaultState());
    },
    setFilesInput(state, fileInputsState) {
        if (fileInputsState.refId !== undefined) {
            let filesToSetNumber = fileInputsState.files.length;
            if (fileInputsState.multiple === true || (fileInputsState.multiple === false && filesToSetNumber === 1)) {
                let filesInputToSet = {
                    names: FileService.getNames(fileInputsState.files),
                    files: fileInputsState.files,
                };
                Vue.set(state.fileInputs, fileInputsState.refId, filesInputToSet);
            } else {
                let error = "FILES.INPUT.STATE - Trying to load more then one file";
                console.error(error);
                return new Error(error);
            }
        }
        console.log("FileInputState -> setFilesInput: ", state.fileInputs);
    },
    addFilesInput(state, fileInputsState) {
        console.debug("FILE.INPUT.SERVICE - addFiles inputs: ", fileInputsState);
        if (fileInputsState.refId !== undefined) {
            console.debug("FILE.INPUT.SERVICE - previousState: ", state.fileInputs[fileInputsState.refId]);
            // If the reference does not exist already, then create it
            let fileInputsToAdd = getFilesInput(state, fileInputsState.refId);
            let filesAlreadyUploadedNumber = fileInputsToAdd.files.length;
            let filesToAddNumber = fileInputsState.files.length;
            // Handle set: do not add the files already present
            if (fileInputsState.multiple === true ||
                (fileInputsState.multiple === false && filesAlreadyUploadedNumber < 1
                    && filesToAddNumber === 1)) {
                console.log("FILE.INPUT.STATE - previous file to add:", fileInputsToAdd);
                for (let i = 0; i < filesToAddNumber; i++) {
                    let toAdd = true;
                    for (let j = 0; j < fileInputsToAdd.files.length; j++) {
                        if (fileInputsToAdd.files[j].name === fileInputsState.files[i].name) {
                            toAdd = false;
                        }
                    }
                    if (toAdd) {
                        fileInputsToAdd.files.push(fileInputsState.files[i]);
                    }
                }
            } else {
                return new Error("Trying to load more then one file");
            }
            fileInputsToAdd.names = FileService.getNames(fileInputsToAdd.files);
            console.log("FILE.INPUT.STATE - getNames: ", fileInputsToAdd.names);
            Vue.set(state.fileInputs, fileInputsState.refId, fileInputsToAdd);
        }
        console.log("FILE.INPUT.STATE  -> addFilesInput final: ", state.fileInputs);
    },
    deleteFileInput(state, fileInputsState) {
        if (fileInputsState.refId !== undefined) {
            console.log("FILE.INPUT.STATE - Delete refId: ", fileInputsState.refId);
            let files = [];
            let inputFiles = getFilesInput(state, fileInputsState.refId);
            if (inputFiles !== undefined) {
                for (let i = 0; i < inputFiles.files.length; i++) {
                    if (inputFiles.files[i].name !== fileInputsState.fileName) {
                        files.push(inputFiles.files[i]);
                    }
                }
                // TODO - names
                inputFiles.files = files;
                Vue.set(state.fileInputs, fileInputsState.refId, inputFiles);
            }
        }
    },
    addFilesInLoading(state, fileInLoadingState) {
        if (fileInLoadingState.refId !== undefined) {
            let filesInLoadingToSet = getFilesInLoading(state, fileInLoadingState.refId);
            filesInLoadingToSet.push(fileInLoadingState);
            Vue.set(state.fileInLoading, fileInLoadingState.refId, filesInLoadingToSet);
        }
    },
    setFilesInLoading(state, fileInLoadingState) {
        if (fileInLoadingState.refId !== undefined) {
            Vue.set(state.fileInLoading, fileInLoadingState.refId, fileInLoadingState);
        }
    },
    deleteFileInLoading(state, fileInLoadingState) {
        if (fileInLoadingState.refId !== undefined) {
            let filesInLoading = getFilesInLoading(state, fileInLoadingState.refId);
            if (filesInLoading !== undefined) {
                Vue.delete(state.fileInLoading[fileInLoadingState.refId], fileInLoadingState.name);
                if (Object.keys(state.fileInLoading[fileInLoadingState.refId]).length === 0) {
                    Vue.delete(state.fileInLoading, fileInLoadingState.refId);
                }
                //console.log("FILE.IN.LOADING - STATE: ", state.fileInLoading);
            }
        }
    },
    updateFileInLoading(state, fileInLoadingState) {
        //console.log("FILE.IN.LOADING - INPUT: ", fileInLoadingState);
        //console.log("FILE.IN.LOADING - STATE: ", state.fileInLoading);
        if (fileInLoadingState.refId !== undefined) {
            let filesInLoadingToSet = getFilesInLoading(state, fileInLoadingState.refId);
            //console.log("FILE.IN.LOADING - filesInLoadingToSet: ", filesInLoadingToSet);
            filesInLoadingToSet[fileInLoadingState.name] = {progress: fileInLoadingState.progress,};
            Vue.set(state.fileInLoading, fileInLoadingState.refId, filesInLoadingToSet);
            //console.log("FILE.IN.LOADING - STATE: ", state.fileInLoading);
        }
    },
};

function getFilesInput(state, refId) {
    console.log("FILE.STATE.GOT - refId: ", refId);
    console.log("FILE.STATE.GOT - state.fileInputs: ", state.fileInputs);
    console.log("FILE.STATE.GOT - state.fileInputs[refId]: ", state.fileInputs[refId]);

    let fileInputs = {};
    if (state.fileInputs[refId] === undefined) {
        fileInputs = {
            names: "",
            files: [],
        };
    } else {
        // else get the files (already loaded in the form)
        fileInputs = state.fileInputs[refId];
    }
    console.log("FILE.STATE.GOT: final", fileInputs);
    return fileInputs;
}

function getFilesInLoading(state, refId) {
    let filesInLoading = {};
    if (state.fileInLoading[refId] === undefined) {
        filesInLoading = {};
    } else {
        // else get the files (already loaded in the form)
        filesInLoading = state.fileInLoading[refId];
    }
    return filesInLoading;
}


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
